
<ws-wrapper
  :wrap="!!tooltip"
  element="span"
  class="ws-button-wrapper"
>
  <q-btn
    ref="qBtn"
    unelevated
    v-bind="$attrs"
    :loading="ajax ? ajaxLoading : loading"
    class="ws-button"
    :flat="flat"
    :class="[
      ...(buttonClasses ? buttonClasses : []),
      {
        primary,
        secondary,
        ghost,
        light,
        small,
        smaller,
        dark,
        'darken-on-hover': darkenOnHover,
        'is-loading': loading || ajaxLoading,
        'use-paddings': usePaddings,
        'icon-only': iconOnly,
        'icon-right': iconRight,
      }
    ]"
    :ripple="isTheme(Theme.ADMIN)"
    v-on="!ajax ? $listeners : { click: buttonAjaxCall }"
  >
    <!-- credit: https://stackoverflow.com/a/50892881/861615 -->
    <template v-for="(_, slot) of slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>

    <ws-icon
      v-if="icon && !iconRight"
      class="ws-button-icon"
      :color="iconColor"
      :class="`ws-button-icon--${icon}`"
      :name="icon"
      :size="iconSizeCalc"
    />

    <!-- BEWARE $slots.default is not reactive, cannot be moved to computed values -->
    <div
      v-if="hasLabel && !iconOnly"
      class="slot-content"
      :class="{
        'q-pl-sm': iconAndContent && !iconRight,
        'q-pr-sm': iconAndContent && iconRight,
        'ws-typo-button-desktop': forcedDesktop,
      }"
    >
      <slot></slot>
      <span
        v-if="label && !iconOnly"
        :class="{ 'ws-typo-button-desktop': forcedDesktop }"
      >{{ $t(label) }}</span>
    </div>

    <ws-icon
      v-if="icon && iconRight"
      class="ws-button-icon"
      :class="`ws-button-icon--${icon}`"
      :name="icon"
      :size="iconSizeCalc"
    />

    <template
      v-if="useThemeSpinner"
      v-slot:loading
    >
      <ws-spinner :color="loaderColorResolved" :width="isTheme(Theme.ACTIVE_24) ? '50px' : undefined" />
    </template>
  </q-btn>
  <ws-tooltip
    v-if="tooltip"
    :content-class="tooltipClass"
    :anchor="tooltipAnchor"
    :self="tooltipSelf"
    :delay="200"
    arrow-position="bottom"
  >
    {{ $t(tooltip) }}
  </ws-tooltip>
</ws-wrapper>
